import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Funcionario } from 'src/app/core/funcionario';
import { Objetivo } from 'src/app/core/objetivo';
import { Programa } from 'src/app/core/programa';
import { FuncionarioService } from 'src/app/services/funcionario/funcionario.service';
import { ObjetivoService } from 'src/app/services/objetivo/objetivo.service';
import { ProgramaService } from '../../../../services/programa/programa.service';
import { DataUtilService } from 'src/app/services/commons/data-util.service';

@Component({
  selector: 'dados-programa',
  templateUrl: './dados-programa.component.html',
  styleUrls: ['./dados-programa.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class DadosProgramaComponent implements OnInit {

  @Input() programa: Programa = new Programa();

  objetivos: Objetivo[];
  funcionarios: Funcionario[];
  programas: Programa[];

  constructor(private dataUtilService: DataUtilService, 
    private objetivoService: ObjetivoService,
    private funcionarioService: FuncionarioService,
    private programaService: ProgramaService
  ) {
  }

  ngOnInit() {

    this.inicializarObjetos();

    this.funcionarioService.getAllByCombo().subscribe((funcionarios: Funcionario[]) => {
      this.funcionarios = funcionarios;
    })

    this.objetivoService.getAll().subscribe((objetivos: Objetivo[]) => {
      this.objetivos = objetivos;
    })

    this.programaService.getAll().subscribe((programas: Programa[]) => {
      this.programas = programas;
    });

  }
  inicializarObjetos() {
    this.programa.objetivo = new Objetivo();
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }
}
